var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18245"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8567",
    d: "M488.193 497.813a60.276 60.276 0 0 1 13.261 0 5.639 5.639 0 0 1 4.978 4.917 57.758 57.758 0 0 1 0 13.434 5.638 5.638 0 0 1-4.978 4.917 60.3 60.3 0 0 1-13.261 0 5.638 5.638 0 0 1-4.978-4.917 57.764 57.764 0 0 1 0-13.434 5.639 5.639 0 0 1 4.978-4.917zm13.025 2.106a58.255 58.255 0 0 0-12.788 0 3.519 3.519 0 0 0-3.1 3.059 55.709 55.709 0 0 0 0 12.939 3.519 3.519 0 0 0 3.1 3.059 58.247 58.247 0 0 0 12.788 0 3.517 3.517 0 0 0 3.1-3.059 55.548 55.548 0 0 0 0-12.939 3.517 3.517 0 0 0-3.101-3.059z",
    transform: "translate(-482.823 -497.447)",
    style: {
      fill: "#8c8d99",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18325"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.181 270.48 373 264.3a1.007 1.007 0 0 0-1.414 0l-.839.84a1.007 1.007 0 0 1-1.414 0l-1.9-1.9",
    transform: "translate(-361.433 -255.241)",
    style: {
      fill: "none",
      stroke: "#f44336",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "path",
    d: "M376.181 266.24h3v-3",
    transform: "translate(-361.433 -251.047)",
    style: {
      fill: "none",
      stroke: "#f44336",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.19267b24908c653209aff87948f0e3df.svg";
export { ForwardRef as ReactComponent };